import { render, staticRenderFns } from "./SelectReservoirsList.vue?vue&type=template&id=2766016a&"
import script from "./SelectReservoirsList.vue?vue&type=script&lang=js&"
export * from "./SelectReservoirsList.vue?vue&type=script&lang=js&"
import style0 from "./SelectReservoirsList.vue?vue&type=style&index=0&id=2766016a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports